module.exports = "<div matRefDialog><app-bundle-details [bundle]=\"bundle\"></app-bundle-details></div>\n"